export default {
  blue: {
    COLOR_CONTAINER_BG: '#12263b',
    COLOR_CONTAINER_TEXT: '#ffffff',
  },
  white: {
    COLOR_CONTAINER_BG: '#ffffff',
    COLOR_CONTAINER_TEXT: '#222'
  }
};
